import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getEntrepreneurProfiles } from "../utils/api";
import MatrimonyHeader from "../components/MatrimonyHeader";
import EntrepreneurHero from "../components/EntrepreneurHero";
import Footer from "../components/Footer";
import MatriHeader from "../components/MatriHeader";

const EntrepreneurProfilesPage = () => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfiles = async () => {
      try {
        const data = await getEntrepreneurProfiles();
        setProfiles(data);
      } catch (err) {
        console.error("Failed to fetch entrepreneur profiles:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProfiles();
  }, []);

  if (loading) return <div className="py-10 text-center">Loading...</div>;
  if (profiles.length === 0)
    return <div className="py-10 text-center">No Entrepreneur profiles found.</div>;

  return (
    <>
    <MatriHeader />
    <EntrepreneurHero />
    <div className="py-10 px-4 max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold mb-6">Entrepreneur Profiles</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {profiles.map((profile) => (
          <div key={profile._id} className="bg-white rounded-3xl overflow-hidden shadow-lg relative">
            <img
              src={profile.images?.[0] || '/m2.png'}
              alt={profile.fullName}
              className="w-full h-[300px] object-cover"
            />
            <div className="bg-gradient-to-t from-black to-transparent text-white p-4 absolute bottom-0 left-0 right-0">
              <h3 className="text-lg font-bold mb-1">{profile.fullName}</h3>
              <div className="text-xs grid grid-cols-2 gap-2 px-4 py-2">
                <span>{profile.gender}</span>
                <span>{profile.height}</span>
              </div>
              <button
                className="mt-3 px-6 py-2 bg-gradient-to-r from-[#E7603C] to-[#B9309A] rounded-full text-sm"
                onClick={() => navigate(`/matrimony/profile-details/${profile._id}`)}
              >
                View Profile
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
    <Footer />
    </>
  );
};

export default EntrepreneurProfilesPage;
